import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../styles/style.css';
import MainSidebar from '../components/MainSidebar';
import MyProfilePosts from '../components/MyProfilePosts';
import MyProfilePostsCompact from '../components/MyProfilePostsCompact';
import MyMediaPosts from '../components/MyMediaPosts';
import dropdownvertical from '../assets/images/drop_vertical.svg';
import search_icon from '../assets/images/search_icon.svg';
import verified from '../assets/images/verified.svg';
import back_btn from '../assets/images/back_btn.svg';
import subscrption_count from '../assets/images/Subscriptions.svg';
import whitedrop_down from '../assets/images/whitedrop_down.svg';
import Settings_blue from '../assets/images/Settings_blue.svg';
import Shere_blue from '../assets/images/Shere.svg';
import empty_blue from '../assets/images/empty-feed.svg';
import default_header_image from '../assets/images/default_header_image.png';
import default_user from '../assets/images/default_user.webp';
import downarrow from '../assets/images/Down.svg';
import fbicon from '../assets/images/Facebook.svg';
import twittericon from '../assets/images/Twitter.svg';
import instaicon from '../assets/images/Instagram.svg';
import youtubeicon from '../assets/images/YouTube.svg';
import snapicon from '../assets/images/snapchat.svg'; 
import fullviewlist from '../assets/images/FullView.svg'; 
import compactviewlist from '../assets/images/CompactView.svg'; 
import SidebarSearch from '../components/SidebarSearch';
import HomeSidebarFooterLinks from '../components/HomeSidebarFooterLinks';
import FilterDropdownMyProfile from '../components/FilterDropdownMyProfile';
import FilterDropdownMyProfileMedia from '../components/FilterDropdownMyProfileMedia';
import config from '../config/config';

const MyProfile = () => {
  const [userData, setUserData] = useState({ phone: '', user_name: '', name: '', activity_status: '' });
  const [loading, setLoading] = useState(true);
  const [copySuccess, setCopySuccess] = useState('');
  const [fanCount, setFanCount] = useState(0); 
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [totalPosts, setTotalPosts] = React.useState(0);
  const [totalMediaPosts, setTotalMediaPosts] = React.useState(0);
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const toastRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isCompactView, setIsCompactView] = useState(false);
  const [isListView, setIsListView] = useState(false);
  const [posts, setPosts] = useState([]);
  const [filter, setFilter] = useState('all'); 

  // Fetch User Details and Fan Count
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/Login');
      return;
    }

const fetchUserDetails = async () => {
  try {
    const token = localStorage.getItem('token'); // Ensure the token is retrieved
    const response = await axios.get(`${config.baseURL}/current-user-details`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // Extract user details from the response
    const userDetails = response.data.data.user_details;
    const user = response.data.data.user;

    // Set the state with the extracted user data
    setUserData({
      phone: userDetails.phone || '',
      location: userDetails.location || '',
      bio: userDetails.bio || '',
      web_url: userDetails.web_url || '',
      user_profile: userDetails.user_profile || '',
      user_back_profile: userDetails.user_back_profile || '',
      facebook_id: userDetails.facebook_id || '',
      twitter_id: userDetails.twitter_id || '',
      insta_id: userDetails.insta_id || '',
      youtube_id: userDetails.youtube_id || '',
      snap_id: userDetails.snap_id || '',
      activity_status: userDetails.activity_status || '',
      name: user.name || '',
      user_name: user.user_name || ''
    });

    setUserId(user.id); 
    setLoading(false);
  } catch (error) {
    console.error('Error fetching user details', error);
    setLoading(false);
  }
};

    const fetchFanCount = async () => {
      try {
        const response = await axios.get(`${config.baseURL}/fans-users-count`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setFanCount(response.data.total_count);  // Update fan count from API response
      } catch (error) {
        console.error('Error fetching fan count', error);
      }
    };

    fetchUserDetails();
    fetchFanCount();
  }, []); // Empty dependency array to ensure it runs only once on component mount

  // Copy Profile Link Function
 const copyProfileLink = async () => {
    const profileUrl = `${window.location.origin}/${userData.user_name}`;

    try {
      await navigator.clipboard.writeText(profileUrl);
      setToastMessage('Profile link copied to clipboard!');
      setShowToast(true);

      // Remove the 'hide-message' class if it's present
      if (toastRef.current) {
        toastRef.current.classList.remove('hide-message');
      }

      // Set a timeout to add the 'hide-message' class after 2 seconds
      setTimeout(() => {
        if (toastRef.current) {
          toastRef.current.classList.add('hide-message');
        }
      }, 3000); // Hide after 3 seconds

    } catch (error) {
      setErrorMessage('Error copying link');
    }
  };

  // Go back to the previous page
  const handleBackClick = () => {
    navigate(-1); 
  };

  // Update Status Function
  const updateStatus = async (status) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(`${config.baseURL}/update-activity-status`, 
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUserData(prevData => ({ ...prevData, activity_status: status }));
    } catch (error) {
      console.error('Failed to update status', error);
    }
  };

  // Handle Status Change Function
  const handleStatusChange = (event) => {
    const newStatus = event.target.id === 'available' ? 'active' : 'inactive';
    updateStatus(newStatus);
  };


const toggleBio = () => {
  setIsExpanded(!isExpanded);
};

const WORD_LIMIT = 15;

const exceedsWordLimit = (text) => {
  return text.split(' ').length > WORD_LIMIT;
};

const getInitials = (name) => {
  if (!name || typeof name !== 'string' || name.trim() === '') {
    return ''; // Return an empty string or a default fallback if name is invalid
  }

  const nameParts = name.trim().split(' ');
  if (nameParts.length === 1) {
    return nameParts[0][0].toUpperCase();
  }

  return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
};

  const handlePostCountChange = (totalPosts, totalMediaPosts) => {
    setTotalPosts(totalPosts);
    setTotalMediaPosts(totalMediaPosts);
  };

  const isMediaTabDisabled = totalMediaPosts === 0; 

  const handleViewToggle = () => {
    setIsCompactView((prev) => !prev);
  };

  const handleViewToggleMedia = () => {
    setIsListView((prev) => !prev);
  };

useEffect(() => {
  if (userData && userData.user_name) {
    const capitalizedUserName = userData.user_name.charAt(0).toUpperCase() + userData.user_name.slice(1);
    document.title = `${capitalizedUserName} - PatreonPass`;
  } else {
    document.title = 'PatreonPass';
  }
}, [userData]);


  return (
    <div>
      <div className="main_patreonpass_wrapper"> 
          <div className="patreonpass_container">
            <div className="left_sidebar">
              <MainSidebar />
            </div>
            <div className="patreonpass_main_content" id="content">

               <div className="left_main_content">
                      <div className="middlw_wrap">
                        <div className="b_profile_wrapper">
                          <div className="b_profile_header">
                            <div className="profile_head">
                              <div className="profile_head_left">
                                <div className="head_profile_content">
                                  <div className="head_profile_content_left">
                                    <button className="profile_back_btn" onClick={handleBackClick}>
                                      <img src={back_btn} alt="" />
                                    </button>
                                  </div>
                                  <div className="head_profile_content_left">
                                    <div className="profile_name_head">{userData.name}</div>
                                    <div className="profile_bottom_head  my_profile_margin_remove">
                                      <ul className="list_below_name">
                                        <li>
                                         
                                          <Link className="link_count" to="/fans">  <img src={subscrption_count} /> {fanCount}</Link>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="profile_head_right">
                                <div className="head_dropdown">
                                  <ul>
                                    <li className="nav-item dropdown">
                                      <a
                                        className="nav-link link_btn_effect dropdown-toggle"
                                        href="#"
                                        id="productsDropdown"
                                        role="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <img
                                          className="icon_dropdown"
                                          src={whitedrop_down}
                                          alt=""
                                        />
                                      </a>
                                      <ul
                                        className="dropdown-menu"
                                        aria-labelledby="productsDropdown"
                                      >
                                        <li className="dropdown">
                                          <Link className="dropdown-item" onClick={copyProfileLink}>
                                            {" "}
                                            Copy link to profile
                                          </Link>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div className="img_wrap">
                              <img
                                src={userData.user_back_profile || default_header_image}
                                alt="Background"
                              />
                            </div>
                          </div>
                          <div className="b_profile_user_details">
                            <div className="b_profile_user_details_wrap">
                              <div className={`profile_avatar ${userData.activity_status === 'active' ? 'user_online_status' : ''}`}>
                                <Link to={`/${userData.user_name}`} className="profile_link">
                                  {userData.user_profile ? (
                                    <img
                                      src={userData.user_profile}
                                      alt="User Profile"
                                    />
                                  ) : (
                                    <span className="profile_name_none_image">
                                      {getInitials(userData.name)}
                                    </span>
                                  )}
                                </Link>
                              </div>

                              <div className="profile_head_right_icons">
                                <div className="btns_profile_blue btns_for_myprofile">
                                  <Link className="edit_profile_icon" to="/editprofile">
                                    <img src={Settings_blue} alt="" /> Edit
                                    profile
                                  </Link>
                                  <Link onClick={copyProfileLink}>
                                    <img src={Shere_blue} alt="" />
                                  </Link>
                                </div>
                              </div>
                            </div>
                            <div className="profile_social_wrap">
                              <div className="profile_social_wrap_head">
                                <div className="head_profile_content_left">
                                  <div className="profile_name_head">{userData.name}</div>
                                  <div className="profile_bottom_head">
                                    <ul className="list_below_name my_profile_menu">
                                          <li>@{userData.user_name}</li>
                                          <li className="nav-item dropdown">
                                            <a
                                              className="nav-link link_btn_effect dropdown-toggle"
                                              href="#"
                                              id="statusDropdown"
                                              role="button"
                                              data-bs-toggle="dropdown"
                                              aria-expanded="false"
                                            >
                                             {userData.activity_status === 'active' ? 'Available now' : 'Invisible'} <img src={downarrow} alt="Dropdown" />
                                            </a>
                                            <ul className="dropdown-menu" aria-labelledby="statusDropdown">
                                              <li className="dropdown">
                                                <input
                                                  type="radio"
                                                  id="available"
                                                  name="status"
                                                  checked={userData.activity_status === 'active'}
                                                  onChange={handleStatusChange}
                                                />
                                                <label htmlFor="available" className="dropdown-item">
                                                  Available
                                                </label>
                                              </li>
                                              <li className="dropdown">
                                                <input
                                                  type="radio"
                                                  id="invisible"
                                                  name="status"
                                                  checked={userData.activity_status === 'inactive'}
                                                  onChange={handleStatusChange}
                                                />
                                                <label htmlFor="invisible" className="dropdown-item">
                                                  Invisible
                                                </label>
                                              </li>
                                            </ul>
                                          </li>
                                        </ul>
                                  </div> 

                                   <div className="profile_social_wrap_middle middle_text_code">
                                    {userData.bio && exceedsWordLimit(userData.bio) ? (
                                      <>
                                        {isExpanded ? (
                                          <>
                                            <p>{userData.bio || 'Bio not available'}</p>
                                            <Link className="more_text" onClick={toggleBio}>Collapse info</Link>
                                          </>
                                        ) : (
                                          <>
                                            <p className="bio-truncated">
                                              {userData.bio ? userData.bio.split(' ').slice(0, WORD_LIMIT).join(' ') + '...' : 'Bio not available'}
                                            </p>
                                            <Link className="more_text" onClick={toggleBio}>More info</Link>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <p>{userData.bio || 'Bio not available'}</p>
                                    )}
                                  </div> 

                                  <div className="social_icons_profile">
                                    {userData.facebook_id && (
                                      <a href={userData.facebook_id} target="_blank" rel="noopener noreferrer">
                                        <img src={fbicon} alt="Facebook" /> My Facebook
                                      </a>
                                    )}
                                    {userData.twitter_id && (
                                      <a href={userData.twitter_id} target="_blank" rel="noopener noreferrer">
                                        <img src={twittericon} alt="Twitter" /> My Twitter
                                      </a>
                                    )}
                                    {userData.insta_id && (
                                      <a href={userData.insta_id} target="_blank" rel="noopener noreferrer">
                                        <img src={instaicon} alt="Instagram" /> My Instagram
                                      </a>
                                    )}
                                    {userData.youtube_id && (
                                      <a href={userData.youtube_id} target="_blank" rel="noopener noreferrer">
                                        <img src={youtubeicon} alt="YouTube" /> My YouTube
                                      </a>
                                    )}
                                    {userData.snap_id && (
                                      <a href={userData.snap_id} target="_blank" rel="noopener noreferrer">
                                        <img src={snapicon} alt="Snapchat" /> My Snapchat
                                      </a>
                                    )}
                                  </div>

                                </div>
                              </div>
                              <div className="my_profile_gap" />
                            </div>
                          </div>
                        </div>
                        <div className="post_media_block">
                          <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link active"
                                id="posts-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#posts"
                                type="button"
                                role="tab"
                                aria-controls="posts"
                                aria-selected="true"
                              >
                              {totalPosts > 0 ? `${totalPosts} Posts` : "No posts"}
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link ${isMediaTabDisabled ? 'disabled_tab' : ''}`}
                                id="media-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#media"
                                type="button"
                                role="tab"
                                aria-controls="media"
                                aria-selected="false"
                                tabIndex={-1}
                              >
                              {totalMediaPosts > 0 ? `${totalMediaPosts} Media` : "No Media"}
                              </button>
                            </li>
                          </ul>
                          {/* Tab Content */}
                          <div className="tab-content" id="myTabContent">
                            <div
                              className="tab-pane fade show active"
                              id="posts"
                              role="tabpanel"
                              aria-labelledby="posts-tab"
                            > 
                              <div className="post_top_section_head collection_tabs_content"> 
                                <div className="title_post_head">RECENT</div>
                                <div className="title_post_head_shorting my_profile_shortings">
                                  <div className="list_type_view">                                      
                                      <div className="views_type"> 
                                        {isCompactView ? (
                                          <img
                                            src={fullviewlist}
                                            alt="Full View"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleViewToggle}
                                          />
                                        ) : (
                                          <img
                                            src={compactviewlist}
                                            alt="Compact View"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleViewToggle}
                                          />
                                        )}
                                      </div>
                                  </div> 

                                </div>
                              </div>

                              {isCompactView ? (
                                <MyProfilePostsCompact userId={userId} filter={filter} posts={posts} onPostCountChange={handlePostCountChange}  isCompactView={isCompactView}  />
                              ) : (
                                <MyProfilePosts userId={userId} filter={filter} onPostCountChange={handlePostCountChange} posts={posts}  isCompactView={isCompactView}  />
                              )}

                            </div>
                            <div
                              className="tab-pane fade"
                              id="media"
                              role="tabpanel"
                              aria-labelledby="media-tab"
                            >  

                            <div className="post_top_section_head collection_tabs_content" >
                                <div className="title_post_head">RECENT</div>
                                <div className="title_post_head_shorting my_profile_shortings">
                                  <div className="list_type_view">                                      
                                      <div className="views_type">
                                        {isListView ? (
                                          <img
                                            src={compactviewlist}
                                            alt="Compact View"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleViewToggleMedia}
                                          />
                                        ) : (
                                          
                                          <img
                                            src={fullviewlist}
                                            alt="Full View"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleViewToggleMedia}
                                          />
                                        )}
                                      </div>
                                  </div>

                                
                                </div>  
                              </div>

                              {isListView ? (
                                <MyProfilePosts userId={userId} filter={filter} onPostCountChange={handlePostCountChange}  isCompactView={isCompactView}  />                                
                              ) : (
                                <MyProfilePostsCompact userId={userId} filter={filter} onPostCountChange={handlePostCountChange}  isCompactView={isCompactView}  />
                              )}

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
 

               <div className="right_main_content">
                  <SidebarSearch />
                  <HomeSidebarFooterLinks />
                </div>
            </div>

             <div className="share_text">
                {/* Conditionally render error message */}
                {errorMessage && (
                  <div className="error_message">{errorMessage}</div>
                )}
                {/* Conditionally render toast message */}
                {toastMessage && (
                  <div className="toast_message" ref={toastRef}>
                    {toastMessage}
                  </div>
                )}
              </div>

          </div>
        </div>
    </div>
  );
};

export default MyProfile;
